import Vue from 'vue'
import { Tooltip } from 'ant-design-vue'

Vue.use(Tooltip)

export default Vue.extend({
  template: `
      <div class="custom-tooltip">
        <a-tooltip placement="right" :title="formatCurrency(value)">
          <span style="text-align: right; display: block;"> {{ formatCurrency(value) }}</span>
        </a-tooltip>
      </div>`,
  data: function () {
    return {
      value: '',
      currency: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.currency = settings.currency
    this.value = this.params.value
  },
  methods: {
    // Format Currency
    formatCurrency(cost) {
      if (cost !== undefined && cost !== '' && cost !== 'Total' && cost !== null) {
        return new Intl.NumberFormat(this.currency.currencyFormate, { style: 'currency', currency: this.currency.currency, minimumFractionDigits: 0 }).format(Math.round(Number(cost)))
      }
      if (cost === 'Total') {
        return cost
      }
    },
    getValue() {
      return this.params.value
    },
  },
})
